export default {"src":"/_next/static/media/subtract.e8061a14.svg","height":2,"width":12,"blurWidth":0,"blurHeight":0};